import * as React from "react";
import BajaContainer from "../conteiners/baja-container";

export default function BajaPage() {
  return <BajaContainer></BajaContainer>;
}
